import React from 'react';
import './Card1.css';

const Card1 = () => {

    const features = [
        {
            title: 'Formación de calidad',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
            )
        },
        {
            title: 'Docentes especializados',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                </svg>
            )
        },
        {
            title: 'Metodología práctica',
            icon: (
                <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" />
                </svg>
            )
        },
        {
            title: 'Certificación avalada',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="9"></circle>
                    <circle cx="12" cy="12" r="4" fill="currentColor"></circle>
                </svg>
            )
        },
        {
            title: 'Respaldo institucional',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="9"></circle>
                    <circle cx="12" cy="12" r="5" strokeDasharray="2 2"></circle>
                </svg>
            )
        }
    ];
    return (

        <section className="features-container">
            <div className="features-wrapper">
                {features.map((feature, index) => (
                    <React.Fragment key={index}>
                        <div className="feature-item">
                            <span className="feature-icon">{feature.icon}</span>
                            <h3 className="feature-title">{feature.title}</h3>
                        </div>
                        {index < features.length - 1 && <div className="feature-divider"></div>}
                    </React.Fragment>
                ))}
            </div>
        </section>

    );


}

export default Card1;
